export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'boltHome' */ 'components/bolt/home/home') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "boltSynopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis' },
	{ id: 'socialWall', getter: () => import(/* webpackChunkName: "socialWall" */ 'components/bolt/socialWall/socialWall'), component: 'socialWall' },
	{ id: 'boltGallery', getter: () => import(/* webpackChunkName: "boltGallery" */ 'components/bolt/gallery/gallery'), component: 'gallery' }
];
export const sectionsWithParent = [

];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
